// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__1Gek3","left":"styles_left__2qe49","right":"styles_right__3d9yh"};